<template>
  <div id="about" v-if="this.$store.state.experiences">
    <transition name="fade">
      <div v-show="loaderVisible">
        <loader />
		  </div>
    </transition>
    <div class='section-page-title'>
      <h1>Jun is a web product designer and developer based in Japan.</h1>
    </div>
    <section class='r'>
      <div class='c-10 wrapper-profile-pics'>
        <ul>
          <li class='profile-pic'></li>
          <li class='profile-pic'></li>
          <li class='profile-pic'></li>
        </ul>
      </div>
      <div class='c-10'>
        <p>I am a web product designer and developer based in Japan.</p>
        <p>10+ years of experience in the design world has allowed my creative capabilities range from web product design to coding to motion graphics to branding.</p>
        <br />
        <p>Find out more about me at <a href="https://www.instagram.com/junichiroar/">Instagram</a>, <a href="https://twitter.com/junichiroar">Twitter</a>, <a href="https://www.figma.com/@junichiroar">Figma</a>, <a href="https://dribbble.com/junichirokoyama">Dribbble</a>, <a href="https://github.com/junichirokoyama">GitHub</a>, and <a href="https://www.linkedin.com/in/junichirokoyama/">LinkedIn</a>.</p>
      </div>
    </section>
    <section class='r' v-if="this.$store.state.experiences">
      <h2 class='c-12 txt-section-name'>Work history</h2>
      <div v-for="experience in sortedExperiences" :key="experience.slug" class='c-8 list-experience'>
        <h3>{{ experience.title.rendered }}</h3>
        <p>{{ experience.acf.location }}</p>
        <p v-if="experience.acf.end_date">{{ experience.acf.start_date }} – {{ experience.acf.end_date }}</p>
        <p v-if="!experience.acf.end_date">{{ experience.acf.start_date }} – Current</p>
        <p>{{ experience.acf.role }}</p>
        <p v-html="experience.content.rendered" class='c-10'></p>
      </div>
    </section>
  </div>
</template>

<script>
// Import componetnts
import loader from '/views/loader'
export default {
  name: 'about',
  components: {
    loader
  },
  data () {
    return {
      loaderVisible: true
    }
  },
  created () {
    // HIDE LOADER AFTER 3 SEC
    setInterval(() => {
      if(this.$store.state.projects) {
        this.loaderVisible = false
      }
    }, 2000)
  },
  computed: {
    sortedExperiences: function () {
      // Sort experiences by start year
      return this.$store.state.experiences.slice().sort((a,b) => b.acf.start_date.substr(b.acf.start_date.length - 4) - a.acf.start_date.substr(a.acf.start_date.length - 4))
    }
  }
}
</script>

<style lang="scss" scoped>
#about {
  padding: 0 24px;
  @include media("<=tablet") {
    padding: 24px;
  }
}

section {
  margin-bottom: 20vh;
}

.wrapper-profile-pics {
  @include flex(left, center);
  > ul {
    list-style: none;
    margin: 0;
    padding: 0;
    > li.profile-pic {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 100%;
      background-color: $primary;
      transition: all 0.6s cubic-bezier(0.22, 1, 0.36, 1);
      &:hover {
        width: 100px;
        height: 100px;
      }
      &:first-child {
        background: $accent url("../src/assets/img/me-202012-square-min.jpg") no-repeat center center;
        background-size: cover;
      }
      &:nth-child(2) {
        background: $accent url("../src/assets/img/me-201910-min.png") no-repeat center center;
        background-size: cover;
      }
      &:nth-child(3) {
        background: $accent url("../src/assets/img/me-201808-min.jpeg") no-repeat center center;
        background-size: cover;
      }
    }
  }
}

.list-experience {
  margin-bottom: 10vh;
  @include media("<=tablet") {
    margin-bottom: var(--space-xxl);
  }
}

</style>